import React, { useState, useEffect } from 'react';
import { Input, Button, Flex, useToast, Box, VStack, Text } from '@chakra-ui/react';

const InviteUserComponent = ({ onSuccess }) => {
    const [inviteEmail, setInviteEmail] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [invites, setInvites] = useState([]);
    const toast = useToast();

    const fetchInvites = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/invite/list`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const data = await response.json();
            if (response.ok) {
                setInvites(data.invites);
            }
        } catch (err) {
            console.error('Error fetching invites:', err);
        }
    };

    useEffect(() => {
        fetchInvites();
    }, []);

    const handleInvite = async () => {
        if (!inviteEmail || !inviteEmail.includes('@')) {
            toast({
                title: 'Invalid email',
                description: 'Please enter a valid email address.',
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            return;
        }

        try {
            setIsSending(true);
            const token = localStorage.getItem('authToken');

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/invite`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email: inviteEmail })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to send invitation.');
            }

            toast({
                title: 'Invitation Sent',
                description: `An invitation has been sent to ${inviteEmail}`,
                status: 'success',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });

            setInviteEmail('');
            onSuccess?.();
            await fetchInvites();  // оновити список після надсилання
        } catch (err) {
            toast({
                title: 'Error',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        } finally {
            setIsSending(false);
        }
    };

    const handleResend = async (email) => {
        try {
            setIsSending(true);
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/invite`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ email })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to resend invitation.');
            }

            toast({
                title: 'Invitation resent',
                description: `An invitation has been resent to ${email}`,
                status: 'success',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
            onSuccess?.();
        } catch (err) {
            toast({
                title: 'Error',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Box mt={3}>
            <Flex gap={3} mb={3}>
                <Input
                    placeholder="Enter team member's email"
                    value={inviteEmail}
                    onChange={(e) => setInviteEmail(e.target.value)}
                    isDisabled={isSending}
                />
                <Button
                    variant="outline"
                    onClick={handleInvite}
                    isLoading={isSending}
                    fontWeight={600}
                >
                    Send
                </Button>
            </Flex>

        </Box>
    );
};

export default InviteUserComponent;
